var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-md-6 mt-3" },
      [
        _c("vs-input", {
          staticClass: "w-full",
          attrs: {
            label: "Abreviación",
            maxlength: "10",
            "data-cy": "abreviation"
          },
          model: {
            value: _vm.option.valor,
            callback: function($$v) {
              _vm.$set(_vm.option, "valor", $$v)
            },
            expression: "option.valor"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-md-6 mt-3" },
      [
        _c("vs-input", {
          staticClass: "w-full",
          attrs: {
            label: "Descripción",
            maxlength: "100",
            "data-cy": "description"
          },
          model: {
            value: _vm.option.descripcion,
            callback: function($$v) {
              _vm.$set(_vm.option, "descripcion", $$v)
            },
            expression: "option.descripcion"
          }
        })
      ],
      1
    ),
    _vm._m(0),
    _c(
      "div",
      { staticClass: "col-md-4 mt-3" },
      [
        _c(
          "b-form-checkbox",
          {
            attrs: { name: "uso-numeracion" },
            on: { change: _vm.clearNumeration },
            model: {
              value: _vm.option.extra.uso.numeracion,
              callback: function($$v) {
                _vm.$set(_vm.option.extra.uso, "numeracion", $$v)
              },
              expression: "option.extra.uso.numeracion"
            }
          },
          [_vm._v(" Para numeración ")]
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-md-4 mt-3" },
      [
        _c(
          "b-form-checkbox",
          {
            attrs: { name: "uso-apr" },
            model: {
              value: _vm.option.extra.uso.aprobaciones,
              callback: function($$v) {
                _vm.$set(_vm.option.extra.uso, "aprobaciones", $$v)
              },
              expression: "option.extra.uso.aprobaciones"
            }
          },
          [_vm._v(" Para tipos de Adjuntos de aprobaciones ")]
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-md-4 mt-3" },
      [
        _c(
          "b-form-checkbox",
          {
            attrs: { name: "uso-referencias" },
            model: {
              value: _vm.option.extra.uso.referencias,
              callback: function($$v) {
                _vm.$set(_vm.option.extra.uso, "referencias", $$v)
              },
              expression: "option.extra.uso.referencias"
            }
          },
          [_vm._v(" Para referencias ")]
        )
      ],
      1
    ),
    _vm.option.extra.uso.numeracion
      ? _c("div", { staticClass: "col-md-12 mt-3" }, [
          _c("h5", [_vm._v(" Selecciona que tipo de numeración tendrá ")])
        ])
      : _vm._e(),
    _vm.option.extra.uso.numeracion
      ? _c(
          "div",
          { staticClass: "col-md-6 mt-3" },
          [
            _c(
              "b-form-checkbox",
              {
                attrs: { id: "num-int", name: "num-int" },
                on: {
                  change: function($event) {
                    return _vm.setNumeration("int")
                  }
                },
                model: {
                  value: _vm.option.extra.numInt,
                  callback: function($$v) {
                    _vm.$set(_vm.option.extra, "numInt", $$v)
                  },
                  expression: "option.extra.numInt"
                }
              },
              [_vm._v(" Numeración interna ")]
            )
          ],
          1
        )
      : _vm._e(),
    _vm.option.extra.uso.numeracion
      ? _c(
          "div",
          { staticClass: "col-md-6 mt-3" },
          [
            _c(
              "b-form-checkbox",
              {
                attrs: { id: "num-of", name: "num-of" },
                on: {
                  change: function($event) {
                    return _vm.setNumeration("of")
                  }
                },
                model: {
                  value: _vm.option.extra.numOf,
                  callback: function($$v) {
                    _vm.$set(_vm.option.extra, "numOf", $$v)
                  },
                  expression: "option.extra.numOf"
                }
              },
              [_vm._v(" Numeración oficial ")]
            )
          ],
          1
        )
      : _vm._e(),
    _vm.option.extra.uso.numeracion && _vm.type !== "category"
      ? _c(
          "div",
          { staticClass: "col-md-6 mt-3" },
          [
            _c(
              "b-form-checkbox",
              {
                attrs: { id: "uso-contraloria", name: "uso-contraloria" },
                on: {
                  change: function($event) {
                    return _vm.setManagement("control")
                  }
                },
                model: {
                  value: _vm.option.extra.uso.contraloria,
                  callback: function($$v) {
                    _vm.$set(_vm.option.extra.uso, "contraloria", $$v)
                  },
                  expression: "option.extra.uso.contraloria"
                }
              },
              [_vm._v(" Va a contraloría ")]
            )
          ],
          1
        )
      : _vm._e(),
    _vm.option.extra.uso.numeracion && _vm.type !== "category"
      ? _c(
          "div",
          { staticClass: "col-md-6 mt-3" },
          [
            _c(
              "b-form-checkbox",
              {
                attrs: { id: "uso-tramite", name: "uso-tramite" },
                on: {
                  change: function($event) {
                    return _vm.setManagement("management")
                  }
                },
                model: {
                  value: _vm.option.extra.uso.tramite,
                  callback: function($$v) {
                    _vm.$set(_vm.option.extra.uso, "tramite", $$v)
                  },
                  expression: "option.extra.uso.tramite"
                }
              },
              [_vm._v(" Va a trámite ")]
            )
          ],
          1
        )
      : _vm._e(),
    _vm.type !== "category"
      ? _c(
          "div",
          { staticClass: "col-md-6 mt-3" },
          [
            _c("label", { attrs: { for: "id-doc-digital" } }, [
              _vm._v("Código docDigital")
            ]),
            _c("b-form-input", {
              staticClass: "w-100",
              attrs: { id: "id-doc-digital", "data-cy": "id-doc-digital" },
              model: {
                value: _vm.option.extra.idDocDigital,
                callback: function($$v) {
                  _vm.$set(_vm.option.extra, "idDocDigital", $$v)
                },
                expression: "option.extra.idDocDigital"
              }
            })
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "col-md-12 d-flex justify-content-end" },
      [
        _c(
          "vs-button",
          {
            staticClass: "margin-top",
            attrs: { color: "primary", type: "border", icon: "save" },
            on: {
              click: function($event) {
                return _vm.saveOption()
              }
            }
          },
          [_vm._v(" Guardar ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mt-3" }, [
      _c("h5", [
        _vm._v(
          " Esta opción puede ser usada en distintos formularios de la aplicación, para esto, selecciona en que listados te gustaría verlo "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }